import { useCallback, useRef, useState } from "react";
import classNames from "classnames/bind";
import { GetPageWrapperDataQuery } from "@graphqlTypes";
import LanguageSelectIcon from "@/assets/svg/language-select.svg";
import ArrowRight from "@/assets/svg/arrow-right.svg";

import styles from './LanguageSelect.module.scss';
import { useRouter } from "next/router";
import { getUrlLocale } from "@/core/utils";
const cx = classNames.bind(styles);

type LanguageSelectProps = {
  languages: GetPageWrapperDataQuery["languages"];
};

export default function LanguageSelect({ languages }: LanguageSelectProps) {
  const router = useRouter();
  const [focused, setFocused] = useState(false);
  const selectEl = useRef<HTMLSelectElement>(null);
  const [value, setValue] = useState(getUrlLocale(router.asPath) || 'en');
  const onButtonFocus = (e: React.FocusEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!focused && e.target === e.currentTarget) {
      selectEl.current?.focus();
      setFocused(true);
    }
  }

  const onSelectClick = (e: React.MouseEvent<HTMLSelectElement>) => {
    e.stopPropagation();
  }
  const onSelectChange = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault();
    setValue(e.target.value);
    const currentPath = router.asPath;
    const currentLocale = getUrlLocale(currentPath, false);
    const newLocale = e.target.value;
    let newPath = currentLocale ? currentPath.split(`/${currentLocale}`)[1] || '/' : currentPath;
    if (newLocale !== 'en') newPath = `/${newLocale}${newPath}`;
    window.location.href = newPath;
  }, [router.asPath]);
  const handleBlur = () => {
    setFocused(false);
  }
  return (
    <button
      className={cx(["language-select", { focused }])}
      onFocus={onButtonFocus}
      tabIndex={focused ? -1 : 0}
      data-gtm-section="nav"
    >
      <LanguageSelectIcon className={cx("icon")} />
      <label className={cx("label")}>
        <p className="tag-l">{value}</p>
        <select
          ref={selectEl}
          className={cx("select")}
          name="language"
          id="language"
          value={value}
          tabIndex={-1}
          onBlur={handleBlur}
          onClick={onSelectClick}
          onChange={onSelectChange}
          data-gtm-section="nav"
        >
          {languages?.map((lang) => (
            <option key={lang?.code} value={lang?.code || 'en'}>
              {lang?.native_name}
            </option>
          ))}
        </select>
      </label>
      <ArrowRight className={cx(["icon", "arrow"])} />
    </button>
  )
}